// extracted by mini-css-extract-plugin
export var section = "index-module--section--WQT7n";